module.exports = __webpack_public_path__ + "media/images/karate-1aa6bb7883aa0593d0b4e96fe8299e12.svg";